import { ObjectValues } from '../../app/types/utilityTypes';

export const LID_ENRICHMENT_STATUSES = {
  REQUESTED: 0,
  FAILED: 2,
  COMPLETED: 3,
} as const;

export type LidEnrichmentStatus = ObjectValues<typeof LID_ENRICHMENT_STATUSES>;
